import { Link, useSearchParams } from "react-router-dom";
import {
  Typography,
  Box,
  createTheme,
  ThemeProvider,
  Stack,
  Divider,
} from "@mui/material";

import CollectionsTemplate from "../../../components/CollectionsTemplate/index";
import baseTheme from "../../../themes/baseTheme";
import Tooltip from "@mui/material/Tooltip";
import "../Dashboard.css";
import React, { useState, useImperativeHandle, useRef } from "react"

import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Status from "../../../stories/StatusComponent/StatusComponent";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import "../../../Localization/i18n";
import { useTranslation } from "react-i18next";


export default function DashboardListitem({ status, headers = [], statusRoleMap, ...props }) {
  status = statusRoleMap[status];
  const { t } = useTranslation();
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  // const open = Boolean(anchorEl);

  const { palette } = baseTheme;
  const theme = createTheme({});
  const padding = "16px 24px";

  return (
    <>

      <Box
        display="flex"
        padding={padding}
        borderBottom="solid 1px"
        borderColor={palette.grey[30]}
        alignItems="center"
      >
        <Box width={headers.find((h) => h.id === "vendorName")}>
          <Typography variant="body2">
            <a
              variant="body2"
              style={{ textDecoration: "none", color: "#2A93DB" }}
              href={"/vendordetails?pqid=" + props?.prequalificationId}
            >
              {props?.vendorName}
            </a>
          </Typography>
        </Box>
        <Box width={headers.find((h) => h.id === "indicationTextClient")}>
          <Status type={props?.prequalificationStatusId} />
        </Box>
        <Box width={headers.find((h) => h.id === "prequalificationSubmit")}>
          <Typography variant="body2">
            {props?.prequalificationSubmit ? GetfVDateFormate(props?.prequalificationSubmit) :  t("Dashboard.yetToSubmit")}
          </Typography>
        </Box>
        <Box width={headers.find((h) => h.id === "prequalificationCreate")}>
          <Typography variant="body2">
            {GetfVDateFormate(props?.prequalificationStart)}&thinsp;{t("Dashboard.to")}&thinsp;
            {GetfVDateFormate(props?.prequalificationFinish)}
          </Typography>
        </Box>
        <Box width={headers.find((h) => h.id === "clientName")}>
          <Typography variant="body2">{props?.clientName}</Typography>
        </Box>
        <Box width={headers.find((h) => h.id === "logo")}>
          {/* <a
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              style={{ float: "right", marginLeft: "-10px" }}
              className="text-muted "
            >
              <MoreVertIcon />
              <img src={logo} alt="logo" /> 
            </a>
            <Menu
              anchorEl={anchorEl}
              id="basic-menu"
              open={open}
              style={{ textAlign: "center" }}
              onClose={handleClose}
            >
              <Box
                sx={{ width: "150px", marginTop: "5px", marginBottom: "6px" }}
              >
                <a
                  href="/editcompany"
                  style={{ color: "#000", textDecoration: "none" }}
                >
               {t("Dashboard.editcompany")}
                </a>
              </Box>
              <Divider />
              <Box
                sx={{ width: "150px", marginTop: "5px", marginBottom: "6px" }}
              >
                <a
                  href="/changestatus"
                  style={{ color: "#000", textDecoration: "none" }}
                >
                 {t("Dashboard.changestatus")}
                </a>
              </Box>
            </Menu> */}
        </Box>
      </Box>

    </>
  );
}



